import styled, { css } from 'styled-components'
import {
  TableBodyCell as Cell,
  TableHeader as Header,
  TableHeaderProps,
  TableBodyRow as Row,
} from 'src/components/TableComponents'
import theme from 'src/styles/theme'
import React from 'react'
import { Tooltip } from '@mui/material'
import { ButtonMui } from 'src/components/ButtonMui'

export const Table = styled.table`
  width: 100%;
  display: inline-block;
  border: 1px solid #c7c9c7;
  box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.12);
  border-radius: 0.5rem;

  thead:first-child {
    border-radius: 0.5rem 0.5rem 0 0;
    overflow: hidden;
  }
`

export const Button = styled.button`
  border: 0;
  background-color: transparent;
`

export const TableBodyCell = styled(Cell).attrs<{flex: number, textAlign: string}>(({ flex, textAlign = 'start' }) => (
  {
    style: {
      textAlign,
      fontFamily: 'Work Sans',
      color: '#000000DE',
      fontSize: 12,
      flex,
      display: 'flex',
      alignItems: 'center',
    },
  }))`
`

interface AdditionalHeaderProps extends TableHeaderProps {
  backgroundColor?: string;
}

export const TableHeader = styled(Header)
  .attrs<AdditionalHeaderProps, {style: React.CSSProperties}>(({ backgroundColor }) => ({
    style: {
      backgroundColor: backgroundColor ?? theme.colors.lightBlue2,
      textAlign: 'start',
      fontFamily: 'Work Sans',
      fontSize: '14px',
      fontWeight: 'bold',
      boxShadow: 'none',
      border: 'none',
      outline: 0,
    },
  }))<AdditionalHeaderProps>`
`

export const Text = styled.p`
  margin: 0;
  font-weight: bold;
  font-family: Work Sans;
`

export const ExpirationDate = styled.div`
  width: 6rem;
  font-weight: bold;
  font-family: Work Sans;
`

export const TableBodyCellGroup = styled.tr<{ flex?: number }>`
  display: flex;
  flex-direction: row;
  ${({ flex = 1 }) => css`
      flex: ${flex};
    `}
`

export const TableBody = styled.tbody`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;

  tr:last-child {
    border-radius: 0 0 0.5rem 0.5rem;
    overflow: hidden;
  }
`

export const TableBodyRow = styled(Row)`
  `

export const Image = styled.img`
  width: 22px;
  height: 22px;
`

export const ImageCheck = styled.img`
  width: 14px;
  height: 14px;
`

export const ImageContainer = styled.div`
  position: absolute;
  margin-left: 16px;
  margin-top: -10px;
`

export const QuantityWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Input = styled.input<{ error?: boolean }>`
  width: 100%;
  height: 32px;
  padding: 10px;

  outline: none;
  border: 1px solid #c7c9c7;
  border-radius: 10px;
  text-align: left;

  &:read-only {
    background-color: #f0f0f0;
  }

  ${({ error }) =>
    error
    && css`
      box-shadow: 0 0 1px 1px red;
    `}
`

export const Error = styled.span`
  margin-top: 4px;
  font-size: 12px;
  line-height: 20px;
  color: red;
`
export const NumberText = styled(Text)<{isNegative: boolean}>`
  color: ${({ isNegative }) => isNegative && theme.colors.red};
`
export const ContainerDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: .5rem;

  p {
    font-size: 16px;
  }
`

export const StatusQuantity = styled.div<{backgroundColor: string, color: string}>`
  width: 6rem;
  font-weight: bold;
  font-family: Work Sans;
  padding-left: .2rem;
  background-color : ${({ backgroundColor }) => backgroundColor};
  color: ${({ color }) => color}
`

export const CellTooltip = styled(Tooltip)`
  cursor: pointer;
`

export const AcceptMaxButtonWrapper = styled.span``

export const AcceptMaxButton = styled(ButtonMui).attrs({
  style: {
    fontSize: 11,
    fontFamily: 'Work Sans',
    whiteSpace: 'nowrap',
    height: 22,
    padding: '2px 6px',
    minWidth: 'unset',
    textTransform: 'none',
  },
})``
